/**
 * USERS STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = { permissions_changed: false, update_permissions: false, undo_permissions: false };

// getters
const getters = {
    users_loader: (state) => (id) => {
        alert(id);
        return state.users_loader;
    },
    user: (state) => {
        return state.user;
    },
    users: (state) => {
        return state.users;
    },
    permissions_changed: (state) => {
        return state.permissions_changed;
    },
    update_permissions: (state) => {
        return state.update_permissions;
    },
    undo_permissions: (state) => {
        return state.undo_permissions;
    },
};

// actions
const actions = {
    async fetchUsers({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    let config = { headers: payload.headers ? payload.headers : {} };
                    response = await api.patch(payload.url, body, config);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("mutateUsers", {
                        property: payload.stateProperty,
                        with: response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty],
                    });
                    if (payload.localStorage) {
                        localStorage.setItem(
                            payload.stateProperty,
                            JSON.stringify(response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty])
                        );
                    }
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    mutateUsers(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutatePermissionsChanged(state, payload) {
        state.permissions_changed = payload;
    },
    mutateUpdatePermissions(state, payload) {
        state.update_permissions = payload;
    },
    mutateUndoPermissions(state, payload) {
        state.undo_permissions = payload;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
